module.exports = __webpack_public_path__ + "img/262.clean_storefront.c3bb9cf4.svg";